import gql from "graphql-tag";

// fragment
export const PLANT_GROWTH_TEMPLATE_FRAGMENT = gql`
    fragment plantGrowthTemplate on PlantGrowthTemplateNode {
        id
        name
        numPhases
        seasonEffectMonths
        totalGrowthDays
        maxSalesDays
        totalM2Days
        potSize {
            id
            potSizeCm
        }
        plant {
            id
            name
        }
        plantGrowthTemplatePhaseSet {
            edges {
                node {
                    id
                    phaseNo
                    numDays
                    numPlantsPerM2
                    defaultGreenhouseDepartmentSection {
                        id
                        name
                    }
                }
            }
        }
        createdAt
        updatedAt
    }
`;

// all query
export const PLANT_GROWTH_TEMPLATES_QUERY = gql`
    query {
        plantGrowthTemplates {
            edges {
                cursor
                node {
                    ...plantGrowthTemplate
                }
            }
        }
    }
    ${PLANT_GROWTH_TEMPLATE_FRAGMENT}
`;

// growth templates of a plant
export const GROWTH_TEMPLATES_OF_A_PLANT_QUERY = gql`
    query tenantPlantGrowthTemplates($plant_Id: ID!) {
        tenantPlantGrowthTemplates(plant_Id: $plant_Id) {
            edges {
                node {
                    ...plantGrowthTemplate
                }
            }
        }
    }
`;

// singel query
export const SINGLE_PLANT_GROWTH_TEMPLATE_QUERY = gql`
    query plantGrowthTemplate($id: ID!) {
        plantGrowthTemplate(id: $id) {
            ...plantGrowthTemplate
        }
    }
    ${PLANT_GROWTH_TEMPLATE_FRAGMENT}
`;

// create
export const CREATE_PLANT_GROWTH_TEMPLATE_MUTATION = gql`
    mutation createPlantGrowthTemplate(
        $input: CreatePlantGrowthTemplateInput!
    ) {
        createPlantGrowthTemplate(input: $input) {
            plantGrowthTemplate {
                ...plantGrowthTemplate
            }
        }
    }
    ${PLANT_GROWTH_TEMPLATE_FRAGMENT}
`;

// update
export const UPDATE_PLANT_GROWTH_TEMPLATE_MUTATION = gql`
    mutation updatePlantGrowthTemplate(
        $input: UpdatePlantGrowthTemplateInput!
    ) {
        updatePlantGrowthTemplate(input: $input) {
            plantGrowthTemplate {
                ...plantGrowthTemplate
            }
        }
    }
    ${PLANT_GROWTH_TEMPLATE_FRAGMENT}
`;

// delete
export const DELETE_PLANT_GROWTH_TEMPLATE_MUTATION = gql`
    mutation deletePlantGrowthTemplate(
        $input: DeletePlantGrowthTemplateInput!
    ) {
        deletePlantGrowthTemplate(input: $input) {
            plantGrowthTemplate {
                ...plantGrowthTemplate
            }
        }
    }
    ${PLANT_GROWTH_TEMPLATE_FRAGMENT}
`;
